// api.js
import axios from "axios";
import {
  clearStoredAuth,
  getStoredAccessToken,
  getStoredRefreshToken,
} from "./utils/authStorage";

const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "http://127.0.0.1:8000/api/";

// Public API (no auth header ever)
export const PublicAPI = axios.create({
  baseURL: API_BASE_URL,
  //baseURL: "http://127.0.0.1:8000/api/",
  //baseURL: "https://hindsight-backend.onrender.com/api/",
  //baseURL: "https://api.hindsight.co.in/api/",
});

// Authenticated API (adds JWT if exists)
export const AuthAPI = axios.create({
  baseURL: API_BASE_URL,
});

AuthAPI.interceptors.request.use((req) => {
  const access = getStoredAccessToken();
  if (access) {
    req.headers.Authorization = `Bearer ${access}`;
  }
  return req;
});

let isRefreshing = false;
let refreshQueue = [];

AuthAPI.interceptors.response.use(
  (res) => res,
  async (err) => {
    const originalRequest = err.config;

    if (err.response?.status === 401 && !originalRequest._retry) {
      const refresh = getStoredRefreshToken();

      // No refresh token — session is gone
      if (!refresh) {
        clearStoredAuth();
        window.location.href = "/login";
        return Promise.reject(err);
      }

      // If already refreshing, queue this request
      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          refreshQueue.push({ resolve, reject });
        }).then((token) => {
          originalRequest.headers.Authorization = `Bearer ${token}`;
          return AuthAPI(originalRequest);
        });
      }

      originalRequest._retry = true;
      isRefreshing = true;

      try {
        const res = await axios.post(
          `${AuthAPI.defaults.baseURL}auth/refresh/`,
          { refresh }
        );
        const newAccess = res.data.access;
        localStorage.setItem("access", newAccess);

        // Resolve all queued requests with the new token
        refreshQueue.forEach((p) => p.resolve(newAccess));
        refreshQueue = [];

        originalRequest.headers.Authorization = `Bearer ${newAccess}`;
        return AuthAPI(originalRequest);
      } catch (refreshErr) {
        // Refresh token is also expired — force logout
        refreshQueue.forEach((p) => p.reject(refreshErr));
        refreshQueue = [];
        clearStoredAuth();
        window.location.href = "/login";
        return Promise.reject(refreshErr);
      } finally {
        isRefreshing = false;
      }
    }

    return Promise.reject(err);
  }
);
